import type { Breakstyle, WidgetT } from 'shared/types';

/**
 * Check if the current URL indicates that we are viewing an argument.
 * Matches URLs ending with:
 * /arguments/<123>
 * /arguments/<123>/pdf
 */
export const isArgumentFromLocation = (): boolean =>
    window.location.href.match(/\/arguments\/\d+(\/pdf)?$/) !== null;

/**
 * Fit-to-content height update for the active breakpoint of a single widget.
 * Returns a new widgets array where the target widget's `position[breakpoint].h`
 * is set exactly to `newH` (grows or shrinks). The other breakpoint is left
 * untouched: xs has fewer columns than md, so its required height differs and must
 * never inherit the active breakpoint's value. Every other widget is unchanged.
 */
export const setWidgetActiveBreakpointHeight = (
    widgets: WidgetT[],
    key: WidgetT['key'],
    newH: number,
    breakpoint: Breakstyle,
): WidgetT[] =>
    widgets.map((widget) =>
        widget.key === key
            ? {
                  ...widget,
                  position: {
                      ...widget.position,
                      [breakpoint]: {
                          ...widget.position[breakpoint],
                          h: newH,
                      },
                  },
              }
            : widget,
    );
